import { useState } from "react";
import { Reveal } from "@/components/site/Reveal";
import { ChapterList, WorksheetList } from "@/components/site/Curriculum";

const TABS = [
  { id: "ebook", label: "The eBook", sub: "6 chapters · 25 lessons" },
  { id: "workbook", label: "The Workbook", sub: "180 pages · 11 worksheets" },
];

export const WhatYouGet = () => {
  const [tab, setTab] = useState("ebook");
  return (
    <section data-testid="what-you-get-section" className="border-t border-line">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36">
        <div className="grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="eyebrow">What you get</p>
              <h2 className="font-display mt-5 text-4xl font-medium leading-tight tracking-tight text-white md:text-5xl">Every chapter. Every worksheet.</h2>
              <p className="mt-6 text-zinc-400">No hidden programme, no community you have to join. Here is exactly what is inside.</p>
              <div className="mt-10 flex flex-col gap-2" role="tablist">
                {TABS.map((t) => (
                  <button key={t.id} role="tab" aria-selected={tab === t.id} onClick={() => setTab(t.id)} data-testid={`wyg-tab-${t.id}`}
                    className={`flex items-center justify-between border px-5 py-4 text-left transition-colors ${tab === t.id ? "border-cta bg-[#0a0f1f]" : "border-line hover:border-zinc-500"}`}>
                    <span className="font-display text-white">{t.label}</span>
                    <span className="text-xs text-zinc-400">{t.sub}</span>
                  </button>
                ))}
              </div>
            </div>
          </Reveal>
          <div className="lg:col-span-8">
            <div className={tab === "ebook" ? "block" : "hidden"}><ChapterList /></div>
            <div className={tab === "workbook" ? "block" : "hidden"}><WorksheetList /></div>
          </div>
        </div>
      </div>
    </section>
  );
};
